module.exports = __webpack_public_path__ + "static/og-image-bd6447c4082560190b3fc7f19025d133.png";